<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header v-if="header" class="header" :type="'cart'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="plp">
        <section class="prdDetail">
          <div class="prdSlide slide" id="slide1">
            <div class="badgeArea">
              <span class="badge" v-for="(topTag, tagIndex) in productTags.topTags" :key="tagIndex">
                <img :src="topTag.imgPath" :alt="topTag.tagName" />
              </span>
            </div>
            <ul class="slideList">
              <li v-for="(thumbnail, index) in detailThumbnail" :key="index">
                <span class="img">
                  <img :src="thumbnail" alt="" />
                  <!-- <img src="@/../static/img/mw/temp/temp_product_detail01.png" alt="" /> -->
                </span>
              </li>
            </ul>
          </div>
          <ul class="utilBtn">
            <li>
              <a class="icoBtn zzim" :class="{ on: product.wishItem }" @click="updateWishList(product)">
                <span>찜 ({{ product.wishCount | currency }})</span>
              </a>
            </li>
            <li class="fr">
              <a @click="share" class="icoBtn share">
                <span><span class="blind">공유</span></span>
              </a>
            </li>
          </ul>
          <div class="prdInfo">
            <span class="prdTit">
              {{ product.displayName }}
            </span>
            <p class="prdCode">{{ product.model }}</p>
            <div class="hashtag">
              <span v-for="(bottomTag, tagIndex) in productTags.bottomTags" :key="tagIndex">
                {{ bottomTag.tagName }}
              </span>
            </div>

            <div class="ratingWrap">
              <span class="starRating">
                <span :style="{ width: reviewSummary.averageScore * 20 + '%' }"></span>
              </span>
              <span class="txt">
                <a class="links" @click="goReviewSection()">{{ reviewSummary.totalReviewCount }}건 리뷰</a>
              </span>
            </div>
          </div>
        </section>

        <div class="tabWrap hr prdDetail">
          <ul class="tabList mainTab" id="prd_detail_tab1" v-if="productDetail.saleDivCd == 'RTSL0003' && productDetail.instYn == 'N'">
            <li class="on" role="button" tabindex="0" @click="order_type = 'pay'">구매</li>
          </ul>
          <ul class="tabList mainTab" id="prd_detail_tab1" v-else>
            <li class="on" role="button" tabindex="0" @click="order_type = 'rental'">
              렌탈
              <span class="blind guideTxt">선택됨</span>
            </li>
            <li role="button" tabindex="0" @click="order_type = 'pay'">구매</li>
          </ul>

          <!-- 구매 탭 (일시불일 경우만) -->
          <div class="tabContents" v-if="productDetail.saleDivCd == 'RTSL0003' && productDetail.instYn == 'N'">
            <div class="tabPanel">
              <div class="prdPrice prdDetail">
                <div class="row">
                  <span class="info">구매가</span>
                  <div class="val">
                    <span class="del" v-if="productDetail.saleDcRat >= 1">{{ productDetail.saleAmountBfDc | currency }}원</span>
                    <br />
                    <span class="price">
                      <span class="money pointC1" v-if="productDetail.saleDcRat >= 1">
                        <em>{{ productDetail.saleDcRat }}</em>
                        %
                      </span>
                      <em class="money">{{ productDetail.saleAmount | currency }}</em>
                      원
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  class="downLink"
                  @click="downloadCoupon(purchaseDownloadableCoupon.couponId)"
                  v-if="purchaseDownloadableCoupon.couponId > 0"
                >
                  {{ purchaseDownloadableCoupon.title }}
                </button>
              </div>
            </div>
          </div>

          <!-- 렌탈 탭 -->
          <div class="tabContents">
            <div class="tabPanel">
              <div class="prdPrice">
                <div class="row">
                  <span class="info">렌탈료</span>
                  <div class="val">
                    <span class="price">
                      월
                      <em class="money">{{ productDetail.rentalAmount | currency }}</em>
                      원
                    </span>
                  </div>
                </div>
                <div class="row">
                  <span class="info">예상 혜택가</span>
                  <div class="val">
                    <span class="price pointC1">
                      월
                      <em class="money">{{ productDetail.cardDcAmount | currency }}</em>
                      원
                    </span>
                  </div>
                </div>
                <p class="ar pointC1 txt">
                  제휴카드 청구할인 혜택가 ({{ productDetail.rentalPeriodNm }} 총
                  <template v-if="productDetail.rentalPeriod">
                    {{
                      ((productDetail.rentalAmount - productDetail.cardDcAmount) *
                        productDetail.rentalPeriod.substring(productDetail.rentalPeriod.length - 2, productDetail.rentalPeriod.length))
                        | currency
                    }}원 할인)
                  </template>
                </p>
                <!-- TODO 쿠폰 리스트 -->
                <button
                  type="button"
                  class="downLink"
                  @click="downloadCoupon(rentalDownloadableCoupon.couponId)"
                  v-if="rentalDownloadableCoupon.couponId > 0"
                >
                  {{ rentalDownloadableCoupon.title }}
                </button>
              </div>

              <ul class="detailInfo">
                <li class="on">
                  <div class="accoHead">
                    <h3 class="titH4">렌탈 안내</h3>
                    <button type="button" class="btnIco_acco accoBtn"><span>상세보기</span></button>
                  </div>

                  <div class="accoBody">
                    <table class="tableX">
                      <caption>등록비, 설치비/철거비, 당사 소비자가에 대한 내용입니다.</caption>
                      <colgroup>
                        <col style="width: auto" span="3" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th class="th">등록비</th>
                          <th class="th">설치비/철거비</th>
                          <th class="th">당사 소비자가</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ productDetail.regiAmt | currency }}원</td>
                          <td>
                            {{ productDetail.installAmount | currency }}원
                            <br />
                            {{ productDetail.retnAmt | currency }}원
                          </td>
                          <td>{{ productDetail.saleAmount | currency }}원</td>
                        </tr>
                      </tbody>
                    </table>

                    <ul class="txtList_remark">
                      <li>
                        렌탈료 총합 :
                        <span class="pointC4">{{ productDetail.totalRentalAmt | currency }}원</span>
                        <br />
                        월렌탈료 {{ productDetail.rentalAmount | currency }} 원&nbsp;x&nbsp;계약기간 {{ productDetail.rentalPeriodNm }}
                      </li>
                      <li>단, 등록비 및 설치비/철거비는 가입시에는 면제되나 중도해지시 별도 부과, 도서산간/제주도 추가설치비 및 철거비 발생</li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- 구매 탭 -->
          <div class="tabContents">
            <div class="tabPanel">
              <div class="prdPrice prdDetail">
                <div class="row">
                  <span class="info">구매가</span>
                  <div class="val">
                    <span class="del" v-if="productDetail.saleAmountBfDc !== productDetail.saleAmount">
                      {{ productDetail.saleAmountBfDc | currency }}원
                    </span>
                    <br />
                    <span class="price">
                      <span class="money pointC1" v-if="productDetail.saleDcRat">
                        <em>{{ productDetail.saleDcRat }}</em>
                        %
                      </span>
                      <em class="money">{{ productDetail.saleAmount | currency }}</em>
                      원
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  class="downLink"
                  @click="downloadCoupon(purchaseDownloadableCoupon.couponId)"
                  v-if="purchaseDownloadableCoupon.couponId > 0"
                >
                  {{ purchaseDownloadableCoupon.title }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 배너 -->
        <div class="banner slide mb20" id="slide4">
          <ul class="slideList">
            <li v-for="(banner, index) in bannerList" :key="index">
              <a @click="$router.push(banner.bannerUrl)">
                <span class="img">
                  <img :src="banner.imgURL" :alt="banner.bannerName" />
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div
          class="btnArea two sticky old_btn"
          style="display: none"
          id="orderBtn1"
          v-if="productDetail.saleDivCd == 'RTSL0003' && productDetail.instYn == 'N'"
        >
          <button type="button" class="btn_p" @click="showOrderLayer">{{ this.order_type === 'rental' ? '렌탈하기' : '구매하기' }}</button>
        </div>
        <div class="btnArea two sticky old_btn" style="display: none" id="orderBtn1" v-else>
          <button type="button" class="btn_s" @click="requestConsult">상담신청하기</button>
          <button type="button" class="btn_p" @click="showOrderLayer">{{ this.order_type === 'rental' ? '렌탈하기' : '구매하기' }}</button>
        </div>

        <!-- 카카오쇼핑 버튼 -->
        <div class="btnArea sticky naver_btn" id="orderBtn1">
          <button type="button" class="btn_p naver_btn01 kakao_btn" style="display: none" @click="naver_btn01()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn02 kakao_btn" style="display: none" @click="naver_btn02()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn03 kakao_btn" style="display: none" @click="naver_btn03()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn04 kakao_btn" style="display: none" @click="naver_btn04()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn05 kakao_btn" style="display: none" @click="naver_btn05()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn06" style="display: none" @click="naver_btn06()">
            <span class="naver_icon">
              <span class="naver_txt">네이버</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn07" style="display: none" @click="naver_btn07()">
            <span class="naver_icon">
              <span class="naver_txt">네이버</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn08 kakao_btn" style="display: none" @click="naver_btn08()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn09 kakao_btn" style="display: none" @click="naver_btn09()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn10 kakao_btn" style="display: none" @click="naver_btn10()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn11 kakao_btn" style="display: none" @click="naver_btn11()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
          <button type="button" class="btn_p naver_btn12 kakao_btn" style="display: none" @click="naver_btn12()">
            <span class="naver_icon">
              <span class="naver_txt">카카오</span>
              쇼핑 구매하기
            </span>
          </button>
        </div>

        <!--:productCode="productCode"-->
        <!-- 하단 탭정보 -->
        <ProductDetailTab
          v-if="dataComplete"
          :productCode="product.productCode"
          :product="product"
          :productCommon="productCommon"
          :reviewSummary="reviewSummary"
          :reviewObj="reviewObj"
          :specifications="specifications"
        ></ProductDetailTab>

        <!-- 주문하기 옵션팝업 -->
        <ProductDetailPop
          v-if="dataComplete"
          :productCode="productCode"
          :productDetail="productDetail"
          :productOptions="productOptions"
          :productColors="productColors"
          :orderCuponList="orderCuponList"
          :orderCuponListPurchase="orderCuponListPurchase"
          :prodOptionCollect="prodOptionCollect"
          @close="insertBasketClose"
          @redirectLoginConfirm="redirectLoginConfirm"
        ></ProductDetailPop>

        <!-- 함께 본 상품 -->
        <ProductDetailTogether :productViewTogetger="productViewTogetger" :productIndex="productCode"></ProductDetailTogether>
        <!-- 추천 상품 -->
        <ProductDetailRecommend :productRecommend="productRecommend" :productIndex="productCode"></ProductDetailRecommend>
        <!-- 찜 하기 -->
        <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>

    <ConfirmPop v-if="confirmPop" @confirm="redirectLogin" @cancel="confirmPop = false" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) test-->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import $ from 'jquery';
import { LOGIN_REQUIRE } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';
import UpdateWishList from '@/components/comm/UpdateWishList';
import ProductDetailPop from '@/views/app/product/ProductDetailPop';
import ProductDetailTab from '@/views/app/product/ProductDetailTab';
import ProductDetailTogether from '@/views/app/product/ProductDetailTogether';
import ProductDetailRecommend from '@/views/app/product/ProductDetailRecommend';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'productDetail',
  components: {
    UpdateWishList, // 찜 하기
    ProductDetailPop, // 옵션 정보
    ProductDetailTab, // 탭 정보
    ProductDetailTogether, // 함께 본 상품
    ProductDetailRecommend, // 추천 상품
    ConfirmPop,
    MessagePop,
  },
  data() {
    return {
      dataComplete: false, // 하단 영역 표시
      header: false, // 헤더 영역 표시
      msg: null,
      messagePop: false,
      confirmPop: false,

      userInfo: JwtService.getUserInfo(), // 로그인 사용자 정보
      order_type: 'rental',

      productCode: '', // 상품 코드
      section: '', // 로드 후 이동
      orderType: 'rental', // 주문 타입

      // 상품 기본 정보
      product: {
        wishCount: 0,
        productCode: '',
        displayName: '',
        model: '',
      },
      prodOptionCollect: [], // 상품 옵션 collect 정보 (옵션 변경 시 사용)
      detailThumbnail: [], // 상품 기본 정보 사진 리스트
      productColors: [], // 상품 색상 정보
      productCommon: [], // 렌탈 안내 탭 정보
      productDetail: {
        // 상품 상세 정보
        rentalAmount: 0,
        cardDcAmount: 0,
        regiAmt: 0,
        installAmount: 0,
        retnAmt: 0,
        sellAmount: 0,
        totalRentalAmt: 0,
        rentalPeriodNm: '',
        goodsTpCd: '',
      },

      productOptions: [], // 상품 옵션 정보
      productTags: [], // 상품 태그
      productViewTogetger: [], // 함께 본 상품
      productRecommend: [], // 추천 상품

      reviewSummary: [], // 리뷰 요약 정보
      bannerList: [], // 배너 리스트

      orderCuponList: [], // 쿠폰 정보 - 렌탈
      orderCuponListPurchase: [], // 쿠폰 정보 - 구매
      specifications: [], // 제품 사양 추가 정보
      // 리뷰정보
      reviewObj: {
        productInfo: {
          product: {
            thumbnail: '',
            displayName: '',
            productName: '',
            model: '',
            color: '',
          },
          orderId: '',
        },
        orderDate: '',
      },
      rentalDownloadableCoupon: {
        couponId: 0,
      },
      purchaseDownloadableCoupon: {
        couponId: 0,
      },
    };
  },
  created() {
    this.productCode = this.$route.params.idx;
    if (null != this.$route.query.section) {
      this.section = this.$route.query.section;
    }
  },
  watch: {
    // order_type() {
    //   // console.log(this.order_type);
    //   const productDetailPop = this.$children.find(child => {
    //     return child.$options.name === 'ProductDetailPop';
    //   });
    //   productDetailPop.order_type = this.order_type;
    // },
  },
  mounted() {
    this.selectProductInfo(); // 상품정보 API
    this.selectBannerList(); // 배너 API
    this.putHistoryInit(); // 최근본 상품
    // this.showSection(); // 리뷰 바로 접근
    this.JWTsetMarParam(); // JWT set Marparam (echo_key, g_code)

    //주문옵션
    if ($('.plpDim').length === 0) {
      $('body').append('<div class="plpDim"></div>');
    }
  },
  updated() {
    customjs.accoInit();

    //상품 옵션 선택
    $('.prdSlt > li').each(function () {
      let label = $(this).find('.accoBtn .item').text() + ' 선택';
      $(this).find('.accoBtn').attr('aria-label', label);
      $('.prdSlt > li .accoBody .iptGroup > li input.ipt').bind({
        'click change': function () {
          $(this)
            .parents('.accoBody')
            .siblings('.accoHead')
            .find('.val')
            .text($(this).siblings('label').find('span').text())
            .removeClass('placeholder');
          $(this).parents('.accoBody').stop(true, true).slideUp(300);
          $(this).parents('.accoItem').removeClass('on').find('.accoBtn').attr('aria-expanded', false);
        },
      });
    });
  },
  beforeDestroy() {
    if ($('.plpDim').length != 0) $('.plpDim').remove(); // 검은 부분 제거
  },
  methods: {
    async selectProductInfo() {
      await ApiService.service('GET', '/product/' + this.productCode)
        .then(({ data }) => {
          console.log('data.result>>> ', data.result);
          this.product = data.result.product; // 상품 기본 정보
          if (!isEmpty(this.product.thumbnail)) this.detailThumbnail.push(this.product.thumbnail);
          for (var i = 1; i <= 7; i++) {
            let target = eval('data.result.product.detailThumbnail' + i);
            if (!isEmpty(target)) this.detailThumbnail.push(target);
          }
          if (data.result.productDetail.saleDivCd == 'RTSL0003' && data.result.productDetail.instYn == 'N') {
            console.log('okk');
            this.order_type = 'pay';
          }
          this.productColors = data.result.productColors; // 옵션 색상
          this.productCommon = data.result.productCommon; // 렌탈 안내
          this.productDetail = data.result.productDetail; // 상품 상세 정보
          this.productOptions = data.result.productOptions; // 상품 옵션 정보
          this.productTags = data.result.productTags; // 상품 태그 정보
          this.productViewTogetger = data.result.productViewTogetger; // 함께 본 상품
          this.productRecommend = data.result.productRecommend; // 추천 상품
          this.reviewSummary = data.result.reviewSummary; // 리뷰 요약 정보
          this.specifications = data.result.specifications;
          this.prodOptionCollect = data.result.prodOptionCollect;

          this.reviewObj.productInfo.orderId = this.product.orderId; // 리뷰 정보
          this.reviewObj.productInfo.product.thumbnail = this.product.detailThumbnail1;
          this.reviewObj.productInfo.product.displayName = this.product.displayName;
          this.reviewObj.productInfo.product.productName = this.product.productName;
          this.reviewObj.productInfo.product.model = this.product.model;
          this.reviewObj.productInfo.product.color = this.product.color;
          this.reviewObj.productInfo.product.productCode = this.product.productCode;

          this.selectOrderCouponList('CPAP0001'); // 주문 쿠폰 리스트 - 렌탈
          this.selectOrderCouponList('CPAP0002'); // 주문 쿠폰 리스트 - 구매
          this.selectDownloadbaleCoupon('CPAP0001'); // 다운로드 가능 쿠폰 조회 - 렌탈
          this.selectDownloadbaleCoupon('CPAP0002'); // 다운로드 가능 쿠폰 조회 - 구매
        })
        .catch(({ response }) => {
          console.log(response);
        });

      this.dataComplete = true;
      this.header = true;
      customjs.slideInit('#slide1', false, false, 500, true, 1, 0, 'fraction');
    },
    JWTsetMarParam() {
      // getMarparam에 값이 없을 경우 JWT토큰에 값 세팅
      console.log('jwt => ' + JwtService.getMarParam());

      if (JwtService.getParamTime() != null && JwtService.getParamTime != null) {
        let now = new Date();
        // let savedTime = new Date(JwtService.getParamTime());
        let diffTime = now - diffTime;
        //40분 이상 된 G코드, 에코키 삭제
        if (diffTime / (1000 * 60) > 40) {
          JwtService.destroyMarParam();
        }
      }
      var param = location.search.substr(location.search.indexOf('?') + 1);
      param = param.split('&');
      var temp = '';
      for (var i = 0; i < param.length; i++) {
        temp = param[i].split('=');
        if (temp[0] == 'g') {
          this.gCode = temp[1];
        }
        if (temp[0] == 'echo_key') {
          this.echoKey = temp[1];
        }
        if (!(this.echoKey == undefined && this.gCode == undefined)) {
          var marParam = this.echoKey + '/' + this.gCode;
          JwtService.setMarParam(marParam);
          this.marParam = JwtService.getMarParam();
        }
      }

      // if (!JwtService.getMarParam() || JwtService.getMarParam == null) {
      //   var param = location.search.substr(location.search.indexOf('?') + 1);
      //   param = param.split('&');
      //   var temp = '';
      //   for (var i = 0; i < param.length; i++) {
      //     temp = param[i].split('=');
      //     if (temp[0] == 'g') {
      //       this.gCode = temp[1];
      //     }
      //     if (temp[0] == 'echo_key') {
      //       this.echoKey = temp[1];
      //     }
      //     if (!(this.echoKey == undefined && this.gCode == undefined)) {
      //       var marParam = this.echoKey + '/' + this.gCode;
      //       JwtService.setMarParam(marParam);
      //       this.marParam = JwtService.getMarParam();
      //     }
      //   }
      // }
    },
    // 주문 쿠폰 리스트
    selectOrderCouponList(couponType) {
      ApiService.service('GET', '/product/' + this.product.productCode + '/coupon/type/' + couponType)
        .then(({ data }) => {
          if (couponType == 'CPAP0001') {
            this.orderCuponList = data.result;
          } else {
            this.orderCuponListPurchase = data.result;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    //다운 가능 쿠폰 목록 조회
    selectDownloadbaleCoupon(couponType) {
      /* 20201215 CRM 요청으로 2순위적용 => 20201223 1순위로 변경 */
      // 1순위 다운받을수 있는 쿠폰중 가장 높은 금액
      if (JwtService.getToken()) {
        ApiService.service('GET', '/product/' + this.product.productCode + '/coupon/type/' + couponType + '/downloadable')
          .then(({ data }) => {
            if (data.isSucceed) {
              if (data.result.length > 0) {
                if (couponType == 'CPAP0001') {
                  this.rentalDownloadableCoupon = data.result[0]; // 렌탈 다운가능 쿠폰 조회
                } else {
                  this.purchaseDownloadableCoupon = data.result[0]; // 구매 다운 가능 쿠폰 조회
                }
              }
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
        /*
            const userId = JwtService.getUserInfo().userId;
            ApiService.service('POST', '/product/' + this.product.productCode + '/coupon/downloadable/' + couponType, {
              request: {
                userId: userId,
              },
              serviceType: 'app', //앱일경우: app , 웹일경우: web
            })
              .then(({ data }) => {
                console.log(this.product.productCode);
                console.log(data);
                if (couponType == 'CPAP0001') {
                  this.rentalDownloadableCoupon = data.result; // 렌탈 다운가능 쿠폰 조회
                } else {
                  this.purchaseDownloadableCoupon = data.result; // 구매 다운 가능 쿠폰 조회
                }
              })
              .catch(({ response }) => {
                console.log(response);
              });
            */
      }
      // 2순위 발급된 쿠폰중 가장 높은 금액
      /*
          if (JwtService.getToken()) {
            ApiService.service('GET', 'user/auth/coupon/downloaded/filter/${couponType}/orderby/amount')
              .then(({ data }) => {
                //console.log(data);
                // 유효기간 지난 쿠폰은 삭제
                for (let i in data.result) {
                  //console.log(data.result[i]);
                  if (data.result[i].calcDt < 0) data.result.splice(i, 1);
                }
  
  
                if (couponType == 'CPAP0001') {
                  if (data.result[0] != null) this.rentalDownloadableCoupon = data.result[0]; // 렌탈 다운가능 쿠폰 조회
                } else {
                  if (data.result[0] != null) this.purchaseDownloadableCoupon = data.result[0]; // 구매 다운 가능 쿠폰 조회
                }
              })
              .catch(({ response }) => {
                console.log(response);
              });
          }
          */
    },
    // 쿠폰 다운로드
    downloadCoupon(downloadCouponId) {
      if (!JwtService.getToken()) {
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
      } else {
        let reqParam = {
          request: {
            couponInfo: [],
          },
          serviceType: 'app',
        };

        let coupon = { couponId: downloadCouponId };
        reqParam.request.couponInfo.push(coupon);
        ApiService.service('POST', '/user/auth/coupon', reqParam)
          .then(({ data }) => {
            if (data.isSucceed) {
              this.selectOrderCouponList('CPAP0001'); // 주문 쿠폰 리스트 - 렌탈
              this.selectOrderCouponList('CPAP0002'); // 주문 쿠폰 리스트 - 구매

              this.msg = '쿠폰 다운로드가 완료되었습니다.';
              this.messagePop = true;
            } else {
              this.msg = data.error;
              this.messagePop = true;
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    redirectLoginConfirm: function () {
      this.msg = LOGIN_REQUIRE;
      this.confirmPop = true;
    },
    redirectLogin: function () {
      $('.plpDim').remove(); // 검은 부분 제거
      this.dataComplete = false;
      this.$router.push({ name: 'login', params: { redirect: 'productDetail', param: { idx: this.$route.params.idx } } });
    },
    // 배너 리스트
    async selectBannerList() {
      await ApiService.service('GET', '/resource/banner/16')
        .then(({ data }) => {
          this.bannerList = data.result[0].bannerDtos;
        })
        .catch(({ response }) => {
          console.log(response);
        });
      customjs.slideInit('#slide4', 5000, false, 500, true, 1, 0);
    },
    // 상담 신청하기
    requestConsult() {
      if (this.productDetail.discntFlag == 'Y') {
        // 기간계 단종
        this.msg = '해당 상품은 현재 품절되었습니다.';
        this.messagePop = true;
        return false;
      } else {
        const params = {
          af_content_id: this.productCode,
        };

        window.appsFlyer('af_PDP_reserve', params);
        this.$router.push({
          name: 'requestConsult',
          params: {
            orderType: this.orderType,
            internalProdCode: this.productDetail.internalProdCode,
            productCode: this.productCode,
          },
        });
      }
    },
    // 최근 본 상품 추가
    putHistoryInit() {
      let obj = window.localStorage.getItem('prdHistory');
      let arr = new Array();
      if (!isEmpty(obj)) {
        arr = JSON.parse(obj);
      }
      if (arr.indexOf(this.productCode) > -1) arr.splice(arr.indexOf(this.productCode), 1); //중복된 idx 기존꺼 삭제 후 다시 등록
      if (arr.length > 30) arr.shift(); //30개 이상이면 첫번째 요소 삭제
      arr.push(this.productCode);
      window.localStorage.setItem('prdHistory', JSON.stringify(arr));
    },
    // 리뷰 바로가기
    showSection() {
      if (this.section !== '') {
        if (this.section === 'review') {
          const productDetailTab = this.$children.find((child) => {
            return child.$options.name === 'ProductDetailTab';
          });

          $('#prd_detail_tab2 > li:eq(1)').trigger('click');
          productDetailTab.middleTab(1);

          setTimeout(function () {
            window.scrollTo(0, $('.reviewTop:eq(0)').offset().top - 100);
          }, 1000);
        }
      }
    },
    goReviewSection() {
      $('#prd_detail_tab2 > li:eq(1)').trigger('click');
      setTimeout(function () {
        window.scrollTo(0, $('.titArea:eq(0)').offset().top - 100);
      }, 100);
    },
    // 옵션 팝업 보기
    showOrderLayer() {
      if (this.product.sellStatus != '1' || this.productDetail.discntFlag == 'Y') {
        this.msg = '해당 상품은 현재 품절되었습니다.';
        this.messagePop = true;
        return false;
      }

      if (this.product.displayName.indexOf('결합') > -1) {
        this.msg = '해당 상품은 상담신청하기를 통해 접수 가능합니다.';
        this.messagePop = true;
        return false;
      }

      if (this.product.displayName.indexOf('할부') > -1) {
        this.msg = '해당 상품은 장기할부 전용상품으로 상담신청하기를 통해 접수 가능합니다.';
        this.messagePop = true;
        return false;
      }

      const productDetailPop = this.$children.find((child) => {
        return child.$options.name === 'ProductDetailPop';
      });
      productDetailPop.order_type = this.order_type;

      if (this.order_type === 'rental') {
        $('#orderBtn2 .topArea .tabList > li:eq(0)').trigger('click');
      } else if (this.productDetail.saleDivCd == 'RTSL0003' && this.productDetail.instYn == 'N') {
        $('.directPay').trigger('click');
      } else {
        $('#orderBtn2 .allPay > li:eq(1)').trigger('click');
      }

      $('#orderBtn1').hide();
      $('.plpDim').fadeIn();
      $('#orderBtn2').show();
      $('body').addClass('popOn');
      $('.wrapper').attr({ 'aria-hidden': 'true', tabindex: '-1' });
    },
    // 찜 하기
    updateWishList(product) {
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      product.wishItem = flag;
      product.wishCount += count;
    },
    // 공유하기
    share() {
      const baseURL = process.env.VUE_APP_BASE_URL;
      const deepLinkURL = process.env.VUE_APP_DEEP_LINK_URL;
      const url = deepLinkURL + baseURL + 'product/category/detail/' + this.product.productIndex; // 렌딩페이지 호출 url
      let templateId = 40309;
      let obj = {
        price: this.productDetail.rentalAmount + '',
        img: this.product.thumbnail,
        salePrice: this.productDetail.cardDcAmount + '',
        productName: this.product.displayName,
        productIndex: this.productCode,
        productTitle: '',
        path: baseURL + 'product/category/detail/' + this.product.productIndex,
      };
      const templateArgs = JSON.stringify(obj);
      // 앱
      if (navigator.userAgent.match(/RIX/i)) {
        window.share(url, templateId, templateArgs);
      } else {
        // 모바일 웹
        if (navigator.share) {
          navigator
            .share({ title: '웰릭스렌탈', text: this.product.displayName, url: url + process.env.VUE_WEB_DEEP_LINK_URL })
            .then(() => console.log('공유완료'))
            .catch((err) => console.log('공유실패] ', err));
        } else {
          alert('지원하지 않는 브라우저입니다.');
        }
      }
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
    },
    insertBasketClose() {
      $('#orderBtn1').show();
      $('.plpDim').fadeOut();
      $('#orderBtn2').hide();
      $('body').removeClass('popOn');
      $('.wrapper').attr({ 'aria-hidden': 'false', tabindex: '-1' });
    },

    //네이버쇼핑 버튼
    //01 웰릭스 AI 화이트
    naver_btn01() {
      window.location.href = 'https://store.kakao.com/welrix/products/169728557';
    },
    //02 웰릭스 AI 블루
    naver_btn02() {
      window.location.href = 'https://store.kakao.com/welrix/products/277617904';
    },
    //03 웰릭스 AI 리필 5set
    naver_btn03() {
      window.location.href = 'https://store.kakao.com/welrix/products/276261191';
    },
    //04 웰릭스 AI 리필 6set
    naver_btn04() {
      window.location.href = 'https://store.kakao.com/welrix/products/276302838';
    },
    //05 웰릭스 AI 필터 1ea
    naver_btn05() {
      window.location.href = 'https://store.kakao.com/welrix/products/276232240';
    },
    //06 웰릭스 AI 화이트 리퍼S
    naver_btn06() {
      window.location.href = 'https://smartstore.naver.com/welrixrental/products/8011551760';
    },
    //07 웰릭스 AI 화이트 리퍼A
    naver_btn07() {
      window.location.href = 'https://smartstore.naver.com/welrixrental/products/8011558125';
    },
    //08 웰릭스 바이오 1kg
    naver_btn08() {
      window.location.href = 'https://store.kakao.com/welrix/products/151814349';
    },
    //09 웰릭스 바이오 2kg
    naver_btn09() {
      window.location.href = 'https://store.kakao.com/welrix/products/151815747';
    },
    //10 웰릭스 바이오 1kg 미생물
    naver_btn10() {
      window.location.href = 'https://store.kakao.com/welrix/products/276215521';
    },
    //11 웰릭스 바이오 2kg 미생물
    naver_btn11() {
      window.location.href = 'https://store.kakao.com/welrix/products/276219855';
    },
    //12 웰릭스 빌트인
    naver_btn12() {
      window.location.href = 'https://store.kakao.com/welrix/products/276208355';
    },
  },
};
</script>
<style type="scss" scoped>
.kakao_btn {
  background-color: #f7e111 !important;
  color: #391b1b !important;
}
</style>
